import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { Globals } from '../global/Globals';
import HelpVideos from '../pages/HelpVideos/HelpVideos';
import Welcome from '../pages/Welcome/Welcome';
import Signup from '../pages/SignUp/Signup';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import ProducerRegistration from '../pages/SignUp/ProducerRegistration';
import CompanyRegistration from '../pages/SignUp/CompanyRegistration';
import Home from '../pages/Home/Home';
import Faq from '../pages/FAQ/Faq';
import NotFound from '../pages/Error/NotFound/404NotFound';
import Notifications from '../pages/Notifications/Notification';
import CreateUnsolicited from '../pages/UnsolicitedProposal/CreateUnsolicited';
import EditUnsolicited from '../pages/UnsolicitedProposal/EditUnsolicited';
import CreateNewBrief from '../pages/NewBrief/CreateNewBrief';
import EditNewBrief from '../pages/NewBrief/EditNewBrief';
import VideoTutorials from '../pages/VideoTutorials/VideoTutorials.js';
import ApplyBrief from '../pages/ApplyBrief/ApplyBrief';
import EditProposals from '../pages/EditProposals/EditProposals';
import ActivateAccount from '../pages/ActivateAccount/ActivateAccount';
import ProtectedRouter from './protectedRouter';
import EditCompany from '../pages/Edit/EditCompany';
import EditProducer from '../pages/Edit/EditProducer';
import ProducerProfile from '../pages/Profile/ProducerProfile';
import CompanyProfile from '../pages/Profile/CompanyProfile';
import ProposalHalfSolicated from '../components/HalfPage_Popup/ProposalHalfSolicated';
import ProposalHalfUnsolicated from '../components/HalfPage_Popup/ProposalHalfUnsolicated';
import AddCluster from '../pages/AddCluster/AddCluster';
import InternalHalfPageBreif from '../components/InternalHalfPageBriefs/InternalHalfPageBriefs';
import CompanyRegistrationApproveReject from '../pages/SystemAdminApproveRejectPage/CompanyRegApprovalRejectionScreen';
import ProducerRegApprovalRejectionScreen from '../pages/SystemAdminApproveRejectPage/ProducerRegApprovalRejectionScreen';
import ReviewProposals from '../pages/ReviewProposals/ReviewProposals';
import SmEvaluationPage from '../pages/SeniorManager/SmEvaluationPage';
import UpdateNewUser from '../pages/AddNewUser/UpdateNewUser';
import AddNewUser from '../pages/AddNewUser/AddNewUser';
import Tickets from '../pages/Tickets/Tickets';
import TicketDetails from '../pages/TicketDetails/TicketDetails';
import RaiseTicket from '../pages/RaiseTicket/RaiseTicket';


const Routers = () => {
  return (
    <Router>
        <Routes>
          <Route path={Globals.NAVPATH.ROOT} element={<Welcome />} />
          <Route path={Globals.NAVPATH.VIDEOTUTORIALS} element={<VideoTutorials />} />
          <Route path={Globals.NAVPATH.SIGNUP} element={<Signup />} />
          <Route path={Globals.NAVPATH.RESET_PASSWORD} element={<ForgotPassword />} />
          <Route path={Globals.NAVPATH.PRODUCER_SIGNUP} element={<ProducerRegistration />} />
          <Route path={Globals.NAVPATH.EDIT_UNSOLICITED} element={<ProtectedRouter><EditUnsolicited /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.CREATE_UNSOLICITED} element={<ProtectedRouter><CreateUnsolicited /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.COMPANY_SIGNUP} element={<CompanyRegistration />} />
          <Route path={Globals.NAVPATH.HOME} element={<ProtectedRouter><Home /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.FAQ} element={<ProtectedRouter><Faq /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.TICKETS} element={<ProtectedRouter><Tickets /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.RAISE_TICKET} element={<ProtectedRouter><RaiseTicket /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.TICKET_DETAILS} element={<ProtectedRouter><TicketDetails /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.NOTIFICATION} element={<ProtectedRouter><Notifications /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.NOTFOUND} element={<ProtectedRouter><NotFound /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.CREATE_NEW_BRIEF} element={<ProtectedRouter><CreateNewBrief/></ProtectedRouter>}/>
          <Route path={`${Globals.NAVPATH.EDIT_NEW_BRIEF}/:id`} element={<ProtectedRouter><EditNewBrief/></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.APPLY_BRIEF} element={<ProtectedRouter><ApplyBrief/></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.EDIT_BRIEF} element={<ProtectedRouter><EditProposals/></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.EDITCOMPANY} element={<ProtectedRouter><EditCompany/></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.EDITPRODUCER} element={<ProtectedRouter><EditProducer/></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.PRODUCERPROFILE} element={<ProtectedRouter><ProducerProfile/> </ProtectedRouter>} />
          <Route path={Globals.NAVPATH.COMPANYPROFILE} element={<ProtectedRouter><CompanyProfile/></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.PROPOSALHALFSOLICATED} element={<ProtectedRouter><ProposalHalfSolicated /></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.PROPOSALHALFUNSOLICATED} element={<ProtectedRouter><ProposalHalfUnsolicated /></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.ACTIVATE_ACCOUNT} element={<ActivateAccount />} />
          <Route path={Globals.NAVPATH.ADD_CLUSTER} element={<ProtectedRouter><AddCluster /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.UPDATE_CLUSTER} element={<ProtectedRouter><AddCluster /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.INTERNAL_HALFPAGE_BRIEFS} element={<ProtectedRouter><InternalHalfPageBreif /></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.SYS_ADMIN_COMP_APPROVE_REJECT} element={<ProtectedRouter><CompanyRegistrationApproveReject/></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.SYS_ADMIN_PRODUCER_APPROVE_REJECT} element={<ProtectedRouter><ProducerRegApprovalRejectionScreen/></ProtectedRouter>}/>
          <Route path={Globals.NAVPATH.REVIEW_PROPOSALS} element={<ProtectedRouter><ReviewProposals /></ProtectedRouter>} />         
          <Route path={Globals.NAVPATH.SENIOR_MANAGER_EVALUATION_PAGE} element={<ProtectedRouter><SmEvaluationPage /></ProtectedRouter>} />         
          <Route path={Globals.NAVPATH.ADD_NEW_USER} element={<ProtectedRouter><AddNewUser/></ProtectedRouter>} />
          <Route path={Globals.NAVPATH.UPDATE_NEW_USER} element={<ProtectedRouter><UpdateNewUser/></ProtectedRouter>} />
 
        </Routes>
    </Router>
  )
};

export default Routers;
